import React, { FC } from 'react';

export const AddButtonIcon: FC = () => {
  return (
  <svg 
    width="22" 
    height="22" 
    viewBox="0 0 22 22" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
        d="M10.5192 11.4814L4.70056 11.4814C4.46613 11.4814 4.27447 11.2911 4.27838 11.0567C4.27925 11.0042 4.28028 10.9742 4.28125 10.9559C4.29396 10.7176 4.47289 10.5209 4.71158 10.5209L10.5192 10.5209L10.5192 4.70231C10.5192 4.46788 10.7092 4.27783 10.9437 4.27783L11.0552 4.27783C11.2896 4.27783 11.4797 4.46788 11.4797 4.70231L11.4797 10.5209L17.2983 10.5209C17.5327 10.5209 17.7228 10.711 17.7228 10.9454V11.0569C17.7228 11.2914 17.5327 11.4814 17.2983 11.4814L11.4797 11.4814L11.4797 17.3C11.4797 17.5345 11.2893 17.7261 11.0549 17.7222C11.0024 17.7213 10.9724 17.7203 10.9542 17.7193C10.7158 17.7066 10.5192 17.5277 10.5192 17.289L10.5192 11.4814Z" 
        fill="#FEFEFE"
    />
    <rect x="0.5" y="0.5" width="21" height="21" rx="1.7" stroke="#FEFEFE"/>
  </svg>

  )
}import React, { FC } from 'react';

export const AddButtonIcon: FC = () => {
  return (
  <svg 
    width="22" 
    height="22" 
    viewBox="0 0 22 22" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
        d="M10.5192 11.4814L4.70056 11.4814C4.46613 11.4814 4.27447 11.2911 4.27838 11.0567C4.27925 11.0042 4.28028 10.9742 4.28125 10.9559C4.29396 10.7176 4.47289 10.5209 4.71158 10.5209L10.5192 10.5209L10.5192 4.70231C10.5192 4.46788 10.7092 4.27783 10.9437 4.27783L11.0552 4.27783C11.2896 4.27783 11.4797 4.46788 11.4797 4.70231L11.4797 10.5209L17.2983 10.5209C17.5327 10.5209 17.7228 10.711 17.7228 10.9454V11.0569C17.7228 11.2914 17.5327 11.4814 17.2983 11.4814L11.4797 11.4814L11.4797 17.3C11.4797 17.5345 11.2893 17.7261 11.0549 17.7222C11.0024 17.7213 10.9724 17.7203 10.9542 17.7193C10.7158 17.7066 10.5192 17.5277 10.5192 17.289L10.5192 11.4814Z" 
        fill="#FEFEFE"
    />
    <rect x="0.5" y="0.5" width="21" height="21" rx="1.7" stroke="#FEFEFE"/>
  </svg>

  )
}